import PageHero from "../components/sections/PageHero";
import GoldButton from "../components/ui/GoldButton";
import ScrollReveal from "../components/motion/ScrollReveal";
import StaggerContainer from "../components/motion/StaggerContainer";
import MagneticButton from "../components/motion/MagneticButton";

const topics = [
  "AI systems for operations",
  "CRM and ERP implementation notes",
  "Website growth and conversion strategy",
  "Automation design patterns",
  "Practical product and engineering insights",
  "Industry-specific digital transformation",
];

const Blog = () => (
  <>
    <PageHero
      label="BLOG & INSIGHTS"
      title="Engineering"
      titleAccent="insights."
      subtitle="A home for practical notes, strategy, and implementation thinking from the OWL team."
    />
    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <ScrollReveal direction="up">
          <div
            style={{
              background: "#0E0E0E",
              border: "1px solid rgba(212,168,67,0.18)",
              borderRadius: 4,
              padding: "40px clamp(24px, 4vw, 48px)",
            }}
          >
            <h2
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 300,
                fontSize: "clamp(36px, 4.6vw, 56px)",
                color: "#F8F4EC",
                marginBottom: 16,
              }}
            >
              Editorial stream launching soon.
            </h2>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 16,
                color: "#908A83",
                lineHeight: 1.7,
                marginBottom: 32,
                maxWidth: 720,
              }}
            >
              We&apos;re turning our internal playbooks into public writing. Expect sharp, implementation-focused content across the topics below.
            </p>
            <StaggerContainer stagger={0.08} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16, marginBottom: 40 }}>
              {topics.map((topic) => (
                <div
                  key={topic}
                  style={{
                    padding: "20px 24px",
                    borderRadius: 4,
                    border: "1px solid rgba(212,168,67,0.16)",
                    background: "#111010",
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 15,
                    color: "#F8F4EC",
                    transition: "border-color 0.3s ease",
                  }}
                  className="card-tilt-hover"
                >
                  <span style={{ color: "#D4A843", marginRight: 10 }}>#</span>
                  {topic}
                </div>
              ))}
            </StaggerContainer>
            
            <MagneticButton>
              <GoldButton href="/contact" size="lg">REQUEST A STRATEGY CONVERSATION</GoldButton>
            </MagneticButton>
          </div>
        </ScrollReveal>
      </div>
    </section>
  </>
);

export default Blog;
